import { css } from "@emotion/react";
import {
  breakpoints,
  colors,
  timings,
} from "@mytutor/shared-react-web-components/lib/theme";

const listOfLinksStyle = css`
  margin: 0 8px;

  @media (min-width: ${breakpoints.tablet}px) {
    margin: 0;
  }

  h2 {
    font-size: 20px;
    font-weight: 500;
    line-height: 1.25;
    color: ${colors.neutral8};
    margin: 1em 0;

    @media (min-width: ${breakpoints.tablet}px) {
      margin-bottom: 0.5em;
    }
  }

  ul {
    display: flex;
    flex-wrap: wrap;
    padding: 0;

    a {
      background-color: ${colors.primary1};
      color: ${colors.neutral8};
      border-radius: 4px;
      padding: 6px 12px;
      margin: 0 12px 12px 0;
      transition: ${timings.medium};

      &:hover {
        background-color: ${colors.primary5};
      }
      &:active {
        background-color: ${colors.primary7};
      }
      &:focus {
        background-color: ${colors.primary7};
      }
    }
  }
`;

const ListofLinks = ({ name, links }) => {
  const items = links.map((link) => (
    <a key={link.name} href={link.url}>
      {link.name}
    </a>
  ));
  {
    return (
      <div className="row" css={listOfLinksStyle}>
        <h2>{name}</h2>
        <ul>{items}</ul>
      </div>
    );
  }
};

export default ListofLinks;
